import * as React from 'react';

import Popup from './../../../components/popup';
import Dropdown from 'react-bootstrap/Dropdown';
import { ICoreContext } from '@msdyn365-commerce/core';
import { CategoryHierarchy } from '@msdyn365-commerce/commerce-entities';

export interface IQuickLink {
  name: string;
  categoryId: number;
  url: string;
  target: string;
  filterName: string;
  isPortal: boolean;
  mobileMode: boolean;
  locale: string;
  hierarchy: CategoryHierarchy,
  context: ICoreContext;
  allOptionText: string;
  enableNewLable?: boolean;
  newLableText?: string;
}

/**
 *
 * QuickLink component
 * @extends {React.PureComponent<IQuickLink>}
 */
export class QuickLink extends React.PureComponent<IQuickLink> {
  public state = { width: 0, showPopup: false };

  public render(): JSX.Element | null {
    const childCategories = this.props.hierarchy.Children;
    if (childCategories && childCategories.length > 0) {
      if (this.props.mobileMode) {
        const childs = childCategories.map((child, cindex) => {
          let grandChilds = child?.Children?.map((grandChild, gindex) => 
            <li key={gindex + 1}><a href={grandChild.Url}>{grandChild.Name}</a></li>);
          grandChilds = grandChilds ?? [];
          grandChilds?.unshift(<li key={0} className='first-link'><a href={child.Url}>{this.props.allOptionText}</a></li>)
          return (
            <Dropdown className='row'>
              <Dropdown.Toggle className='shadow-none col-12 d-flex' id={`dropdown-quicklink-${child!.Name!.replace(' ', '_').toLowerCase()}`}>{child.Name}
              <span className='flex-fill text-right'></span>
              </Dropdown.Toggle>
              <Dropdown.Menu renderOnMount={true} aria-labelledby={`dropdown-quicklink-${child!.Name!.replace(' ', '_').toLowerCase()}`}>
                <div className="dropdown-content"><ul key={cindex} aria-label={child.Name}>{grandChilds}</ul></div>
              </Dropdown.Menu>
            </Dropdown>
          );
        });

        return (
          <div className='quicklink-item-group'>
            <div className='item' id={`dropdown-quicklink-${this.props.name.replace(' ', '').toLowerCase()}`}>{this.props.name}{this.props.enableNewLable && <label className='quicklink-item-new'>{this.props.newLableText}</label>}</div>
              <div className="eshop-dropdown-content">{childs}</div>
          </div>
        );
      }

      const childs = childCategories.map((child, cindex) => {
        let grandChilds = child?.Children?.map((grandChild, gindex) => 
          <li key={gindex + 1}><a href={grandChild.Url}>{grandChild.Name}</a></li>);
        grandChilds = grandChilds ?? [];
        grandChilds?.unshift(<li key={0} className='first-link'><a href={child.Url}>{child.Name}</a></li>);
        return <ul key={cindex} aria-label={child.Name}>{grandChilds}</ul>;
      });

      return (
        <Dropdown className='quicklink-item-group'>
          <Dropdown.Toggle className='shadow-none' id={`dropdown-quicklink-${this.props.name.replace(' ', '').toLowerCase()}`}>{this.props.name}{this.props.enableNewLable && <label className='quicklink-item-new'>{this.props.newLableText}</label>}</Dropdown.Toggle>
          <Dropdown.Menu renderOnMount={true}>
            <div className="dropdown-content">{childs}</div>
          </Dropdown.Menu>
        </Dropdown>
      );

    } else {
      const linkStyle = this.props.url === '' ? 'no-link' : (this.props.isPortal ? 'portal' : 'btn shadow-none');
      return (
        <div className='quicklink-item-group'>
          <a href={!this.props.isPortal ? this.props.url : ''} onClick={!this.props.isPortal ? this._handleOnClick : this._handleOnClickPopup} target={!this.props.isPortal ? this.props.target : ''} className={linkStyle}>{this.props.name}</a>
          {this.props.isPortal && <Popup showPopup={this.state.showPopup} name={this.props.name} url={this.props.url} isMobile={this.props.mobileMode} isPortalPopup={true} locale={this.props.locale} callback={this._handleCallback}/>}
          {this.props.enableNewLable && <label className='quicklink-item-new'>{this.props.newLableText}</label>}
        </div>
      );
    }
  }

  private _handleOnClick = () => {
    if (window !== undefined) {
      window.sessionStorage.setItem('qLink', this.props.categoryId.toString());
      window.sessionStorage.setItem('qItem', this.props.name);
      window.sessionStorage.setItem('qFilter', this.props.filterName);
    }
  }

  private _handleOnClickPopup = () => {
    event?.preventDefault();
    this.setState({ showPopup: true});
  }

  private _handleCallback = () => {
    this.setState({ showPopup: false});
  }
}

export default QuickLink;